import { connect } from 'react-redux';
import MediaViewer from './mediaViewer';

const mapStateToProps = ({ detailsPage }) => ({
  productCode: detailsPage.loadedProduct.productCode,
  imageSet: detailsPage.loadedProduct.imageSet,
});

export default connect(mapStateToProps)(MediaViewer);
